var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.24,
    height: 21.564,
    viewBox: "0 0 26.24 21.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27252",
    "data-name": "Group 27252",
    transform: "translate(-55.038 -357.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27224",
    "data-name": "Group 27224",
    transform: "translate(55.5 357.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37859",
    "data-name": "Path 37859",
    d: "M22.878,39.379V33.344H27.1v6.035",
    transform: "translate(-14.663 -21.287)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27223",
    "data-name": "Group 27223",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27225",
    "data-name": "Group 27225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37861",
    "data-name": "Path 37861",
    d: "M42.606,2.6V.5h3.264V4.108",
    transform: "translate(-27.149 -0.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37863",
    "data-name": "Path 37863",
    d: "M17.885,9.428c-2.454-1.718-3.781-2.7-6.234-4.414-.088-.037-.847-.356-.86-.357h-.025a1.205,1.205,0,0,0-.86.357L1.015,11.239A1.207,1.207,0,0,0,2.4,13.217l8.38-5.867",
    transform: "translate(-0.5 -3.13)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37865",
    "data-name": "Path 37865",
    d: "M38.459,18.966l2.071,1.451",
    transform: "translate(-24.525 -12.187)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37867",
    "data-name": "Path 37867",
    d: "M7.706,33.338V42.1H21.959",
    transform: "translate(-5.061 -21.284)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27226",
    "data-name": "Group 27226",
    transform: "translate(71.7 364.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37835",
    "data-name": "Path 37835",
    d: "M333.91,264.93a4.933,4.933,0,0,1,5.123,4.027,5.031,5.031,0,0,1-.344,2.55,33.2,33.2,0,0,1-2.055,4.441c-.376.706-.769,1.4-1.159,2.1a1.264,1.264,0,0,1-2.273.034,41.977,41.977,0,0,1-3.01-5.844,10.778,10.778,0,0,1-.627-2.071,4.155,4.155,0,0,1,.773-3.147A4.551,4.551,0,0,1,333.91,264.93Zm4.523,4.65a6.167,6.167,0,0,0-.11-.754,3.959,3.959,0,0,0-3.029-3.1,3.917,3.917,0,0,0-4.144,1.328,3.634,3.634,0,0,0-.893,3.242,11.04,11.04,0,0,0,.635,1.9,46.52,46.52,0,0,0,2.882,5.57.617.617,0,0,0,1.148-.008c.373-.669.746-1.338,1.1-2.015a32.451,32.451,0,0,0,2.039-4.447A5.763,5.763,0,0,0,338.432,269.58Z",
    transform: "translate(-329.506 -264.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37836",
    "data-name": "Path 37836",
    d: "M367.425,299a3.063,3.063,0,1,1-3.058-3.064A3.087,3.087,0,0,1,367.425,299Zm-3.059-2.391A2.391,2.391,0,1,0,366.753,299,2.391,2.391,0,0,0,364.366,296.613Z",
    transform: "translate(-359.553 -294.237)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.8bd20d2308d787e692a74089de8b867e.svg";
export { ForwardRef as ReactComponent };